import { getAuth } from "firebase/auth";
import { doc, getDoc, getFirestore } from "firebase/firestore";
import addLogDocument from "../addLogDocument"; // Assuming you have this utility for logging
import JSZip from "jszip"; // To handle zip file extraction
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

const generateATH2 = async (xmlUrl, orgData, xmlId, ath_request, prefix) => {
  const token = await getOrRefreshFirebaseToken();
  // Define the endpoint URL
  const url = prefix + `ath-2/xml/${xmlId}/generate_pdf`;

  const fileResponse = await fetch(xmlUrl);
  if (!fileResponse.ok) {
    throw new Error(`Failed to download file: ${fileResponse.status}`);
  }

  const fileBytes = await fileResponse.arrayBuffer();
  if (
    // Check if the file is a ZIP
    !fileResponse.headers.get("content-type")?.includes("application/zip")
  ) {
    throw new Error(
      "the provided file is a " + fileResponse.headers.get("content-type")
    );
  }
  const zip = await JSZip.loadAsync(fileBytes); // Load ZIP file
  let xmlContent = null;
  // Extract the first XML file from the ZIP
  for (const filename in zip.files) {
    if (filename.endsWith(".xml") && !filename.includes("/")) {
      xmlContent = await zip.file(filename).async("string");
      break;
    }
  }

  if (!xmlContent) {
    throw new Error("No XML file found in the ZIP archive");
  }

  const fileBlob = new Blob([xmlContent], { type: "application/xml" });
  const formData = new FormData();
  formData.append("file", fileBlob, "xml_to_generate.xml");
  // Define the request body
  const logo = orgData.logo || "https://i.ibb.co/8Nc2tS4/Placeholder.png";

  console.log("logo", logo);

  formData.append("body", JSON.stringify(ath_request));

  try {
    let start = new Date();
    // Make the POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });

    const auth = getAuth();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      console.error("User not logged in");
      return { url: "", attestationId: "" };
    }

    const userRef = doc(getFirestore(), "user", currentUser.uid);
    const userDoc = await getDoc(userRef);
    const org_id = userDoc.get("org_id");
    let end = new Date();
    let elapsed = end - start;
    const responseText = await response.text();
    // Add log document
    await addLogDocument(
      url,
      prefix,
      userRef,
      org_id,
      response.status.toString(),
      "",
      "",
      {},
      responseText,
      "POST",
      elapsed
    );

    // Check if the request was successful
    if (response.ok) {
      const pdfData = JSON.parse(responseText);
      const url = pdfData.url.trim().replace(/"/g, "");
      const attestationId = pdfData.attestation_id;
      return { url: url, attestationId: attestationId };
    } else {
      console.error(`Failed to send request: ${response.status}`);
      return { url: "", attestationId: "" };
    }
  } catch (error) {
    // Handle exceptions
    console.error(`Exception occurred: ${error.message}`);
    return { url: "", attestationId: "" };
  }
};

export default generateATH2;
